import { render, staticRenderFns } from "./Policy-lookout.vue?vue&type=template&id=1aca05f9&scoped=true&"
import script from "./Policy-lookout.vue?vue&type=script&lang=js&"
export * from "./Policy-lookout.vue?vue&type=script&lang=js&"
import style0 from "./Policy-lookout.vue?vue&type=style&index=0&id=1aca05f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aca05f9",
  null
  
)

export default component.exports